import React from "react";
import { Typography, Box, Card, CardContent, Chip } from "@mui/material";

interface EvacuationPlanInfoProps {
  name: string;
  alarmTypeLabel: string;
  organisationName: string;
  isActive: boolean;
  stepsCount: number;
}

export const EvacuationPlanInfo: React.FC<EvacuationPlanInfoProps> = ({
  name,
  alarmTypeLabel,
  organisationName,
  isActive,
  stepsCount,
}) => {
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          {name}
        </Typography>
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <Chip
            label={alarmTypeLabel}
            color="primary"
            variant="outlined"
          />
          <Chip
            label={organisationName}
            color="secondary"
            variant="outlined"
          />
          <Chip
            label={isActive ? "Aktiv" : "Inaktiv"}
            color={isActive ? "success" : "default"}
            variant="outlined"
          />
        </Box>
        <Typography variant="body1" color="text.secondary">
          Denna checklista innehåller {stepsCount} steg som ska följas i ordning.
        </Typography>
      </CardContent>
    </Card>
  );
};
